import React from 'react'

export default function Avatar ({ src, onClick }) {
  return (
    <img alt={src} onKeyDown={() => {}} src={src} width='64' height='64' onClick={onClick} className='avatar' />
  )
}
